export default "__VITE_ASSET__862558d5__"